var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.5,181.4h-7.6v-7.6c0-9.7-6.1-18.2-15.2-21.5V36.6c0-12.6-10.2-22.9-22.9-22.9 c-12.6,0-22.9,10.2-22.9,22.9v115.7c-9.1,3.2-15.2,11.8-15.2,21.5v7.6H143.3v-7.6c0-9.7-6.1-18.2-15.2-21.5V36.6 c0-12.6-10.2-22.9-22.9-22.9S82.3,24,82.3,36.6v115.7c-9.1,3.2-15.2,11.8-15.2,21.5v7.6h-7.6c-12.6,0-22.9,10.2-22.9,22.9V250 c0,12.6,10.2,22.9,22.9,22.9h381.1c12.6,0,22.9-10.2,22.9-22.9v-45.7C463.4,191.6,453.2,181.4,440.5,181.4z M394.8,29 c4.2,0,7.6,3.4,7.6,7.6v114.3h-15.2V36.6C387.2,32.4,390.6,29,394.8,29z M371.9,173.8c0-4.2,3.4-7.6,7.6-7.6h30.5 c4.2,0,7.6,3.4,7.6,7.6v7.6h-45.7V173.8z M105.2,29c4.2,0,7.6,3.4,7.6,7.6v114.3H97.6V36.6C97.6,32.4,101,29,105.2,29z M82.3,173.8 c0-4.2,3.4-7.6,7.6-7.6h30.5c4.2,0,7.6,3.4,7.6,7.6v7.6H82.3V173.8z M448.2,250c0,4.2-3.4,7.6-7.6,7.6H59.5c-4.2,0-7.6-3.4-7.6-7.6 v-45.7c0-4.2,3.4-7.6,7.6-7.6h381.1c4.2,0,7.6,3.4,7.6,7.6V250z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 250,
    cy: 120.4,
    r: 15.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.1,227.1h45.7v15.2H67.1V227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.1,227.1h45.7v15.2h-45.7V227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189,227.1h45.7v15.2H189V227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.2,227.1h45.7v15.2h-45.7V227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.3,88.1c-17.9-17.9-46.8-17.9-64.7,0c0,0,0,0,0,0l10.8,10.8c12.1-11.5,31.1-11.5,43.1,0L282.3,88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,59.5c16.2,0,31.7,6.4,43.1,17.9l10.8-10.8c-29.8-29.8-78-29.8-107.8,0l10.8,10.8 C218.3,65.8,233.8,59.4,250,59.5L250,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.9,288.1h-2.2c-6.6,0-12.9,2.3-18,6.4l-58.4,47.8c-1.6-9.3-8.4-16.9-17.5-19.5l-54.1-16.2 c-7.1-2.1-14.5-3.2-21.9-3.2h-1.9c-13.5,0-26.7,3.6-38.4,10.4l-65.7,38.3c-1.4-1.9-3.6-3-5.9-3H82.3c-4.2,0-7.6,3.4-7.6,7.6v121.9 c0,4.2,3.4,7.6,7.6,7.6h30.5c4.2,0,7.6-3.4,7.6-7.6v-11.1l78.4-49.9h119.7c1.8,0,3.5-0.6,4.9-1.8l91.7-77.6 c12-10.1,13.5-28.1,3.4-40.1C413.2,291.8,405.2,288.1,396.9,288.1z M105.2,471H89.9V364.3h15.2V471z M405.4,326.6l-89.6,75.8H196.6 c-1.4,0-2.9,0.4-4.1,1.2l-72.1,45.9v-80.8l71.6-41.8c9.3-5.4,19.9-8.3,30.7-8.3h1.9c5.9,0,11.8,0.9,17.5,2.6l54.1,16.2 c5.2,1.6,8.2,7,6.6,12.3c-1.2,4.2-5.1,7-9.5,7h-51.1v15.2h61c1.8,0,3.5-0.6,4.8-1.7l78.1-63.9c2.4-1.9,5.3-3,8.4-3h2.2 c7.3,0,13.2,5.9,13.2,13.2C410.1,320.5,408.4,324.1,405.4,326.6L405.4,326.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceTesting);
export default __webpack_public_path__ + "static/media/Compliance Testing.cdd21ab19c4426fe994a35f0c14f12bb.svg";
export { ForwardRef as ReactComponent };